<div class="printFrames" *ngIf="data">
  <div class="printFrame frame_tl">
    <img class="printFrame_bg" *ngIf="api.env.showBackground" src="./assets/images/print_bg.png" alt="">
    <span class="frame_number">1</span>
    <img class="" [src]="environment.theme.logo" alt="logo" width="100" height="100">
    <div class="flex f_center">
      <div class="f_col f_align_c" *ngIf="api.env.showLogoPrint">
        <img src="./assets/zimmigration.png" width="80px" alt="">
      </div>
      <div class="f_col f_align_c" *ngIf="api.env.showEmblemPrint">
        <img src="./assets/emblem.png" width="80px" alt="">
      </div>
    </div>
  </div>

  <div class="printFrame frame_tr">
    <img class="printFrame_bg" *ngIf="api.env.showBackground" src="./assets/images/print_bg.png" alt="">
    <span class="frame_number">4</span>
    <div class="flex f_align_c mb_10">
      <img class="printFrame_header_icon" src="assets/images/icons_clr/error.png" alt="">
      <span class="frame_title">{{'print.notice.title' | translate}}</span>
    </div>
    <p>{{'print.notice.desc1' | translate}}</p>
    <p>{{'print.notice.desc2' | translate}}</p>
    <div class="flex justify-between flex-grow">
      <span *ngIf="api.userInfo?.server.emailConfig.phone.trim()">TEL: {{api.userInfo?.server.emailConfig.phone}}</span>
      <span class="ml_10" *ngIf="api.userInfo?.server.emailConfig.email">EMAIL: {{api.userInfo?.server.emailConfig.email}}</span>
    </div>
    <div class="flex f_align_c mt_20 mb_20">
      <img class="printFrame_header_icon" src="assets/images/icons_clr/origami.png">
      <span class="frame_title">{{'print.notice.folding' | translate}}</span>
    </div>
    <img class="mb-14" src="assets/images/folding.png" alt="folding" width="320" height="100">
  </div>

  <div class="printFrame frame_bl">
    <img class="printFrame_bg" *ngIf="api.env.showBackground" src="./assets/images/print_bg.png" alt="">
    <span class="frame_number">2</span>
    <div class="flex f_align_c mb_10">
      <img class="printFrame_header_icon" src="assets/images/icons_clr/about.png">
      <span class="frame_title">{{'print.informations' | translate}}</span>
    </div>
    <ng-container>
      <div class="printFrame_data" *ngIf="data.metadata?.FirstName">
        <span>{{'form.name' | translate}}:</span><span>{{data.metadata.FirstName}} {{data.serialized?.Surname || data.metadata?.LastName}}</span>
      </div>
      <div class="printFrame_data" *ngIf="hasValue(data.metadata?.BirthDay, 'date')">
        <span>{{'form.birthDate' | translate}}:</span><span>{{data.metadata?.BirthDay | date}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.metadata?.Nationality && data.metadata.Nationality !== '-'">
        <span>{{'form.nationality' | translate}}:</span><span>{{('DYN.' + data.metadata?.Nationality) | translate}}</span>
      </div>
      <div class="printFrame_data" *ngIf="(data.metadata?.passportNumber || data.metadata?.PassportNumber) && (data.metadata?.passportNumber !== '-' && data.metadata?.PassportNumber !== '-')">
        <span>{{('form.passportNumber') | translate}}:</span><span>{{data.metadata?.PassportNumber}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.operationId">
        <span>{{('document.type.DYN.') | translate}}: </span><span>{{
        isTransit ? ('transit' | translate) :
        documentTypeIsVisaArrivalVariant(data.operationId)
          ? (((data.operationId + '.arrivalPrint') | translate) + (data.externalId ? (' ' + ('paidOnline' | translate)) : ''))
          : (data.operationId | translate)}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.indexed?.['Documents.RequestReason']">
        <span>{{'Documents.RequestReason' | translate}}:</span>
        <span>{{data.indexed?.['Documents.RequestReason'] | translate}}</span>
      </div>
      <div class="printFrame_data" *ngIf="documentTypeIsAnyVisa(data.operationId) && hasValue(data.usageAfter, 'date')">
        <span>{{'visaIntro.validFrom' | translate}}: </span><span>{{data.usageAfter | date}}</span>
      </div>
      <div class="printFrame_data" *ngIf="documentTypeIsAnyVisa(data.operationId) && hasValue(data.usageUntil, 'date')">
        <span>{{'visaIntro.validUntil' | translate}}: </span><span>{{data.usageUntil | date}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.operationId">
        <span>{{'visaIntro.usageCount' | translate}}: </span><span>{{getUsageCount(data.operationId)}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.externalId">
        <span>{{'form.externalId' | translate}}: </span><span>{{data.externalId | lowercase}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.id && api.env.showDemandReference">
        <span>{{'trip.name' | translate}}:</span><span>{{data.batchId | lowercase}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.id">
        <span>{{'application.id' | translate}}:</span><span class="application_id">{{data.id | lowercase}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.metadata.NNI && api.env.printApprovalNNI">
        <span>{{'NNI' | translate}}:</span><span>{{data.metadata.NNI}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.createdAt && api.env.printApprovalCreatedAt">
        <span>{{'createdAt' | translate}}:</span><span>{{data.createdAt | date:'dd/MM/yyyy'}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.timeslot">
        <span>{{'timeslot' | translate}}:</span><span>{{data.timeslot | date:'dd/MM/yyyy HH:mm':'UTC'}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.timeslot_place_id">
        <span>{{'timeslot_place_id' | translate}}:</span><span>{{places.getLongNameFromId(data.timeslot_place_id)}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.motifDemande">
        <span>{{'Motif de la demande' | translate}}:</span><span>{{data.motifDemande}}</span>
      </div>
      <div class="printFrame_data" *ngIf="hasUiPerm(UiPermission.IS_STATUS_PAID_FOR_PRINT)">
        <span>{{'Payment.print' | translate}}:</span><span>{{this.isValid ? ('Payment.validated' | translate) : ('Payment.notvalidated' | translate)}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.currency && data.amountCents !== undefined && hasUiPerm(UiPermission.IS_STATUS_PAID_FOR_PRINT)">
        <span>{{'price' | translate}}:</span><span>{{ data.amountCents / 100 }} {{ data.currency }}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.metadata?.RegistrationPortId">
        <span>{{'print.withdrawal.place' | translate}}:</span><span>{{places.getLongNameFromId(data.metadata.RegistrationPortId)}}</span>
      </div>
      <div class="printFrame_data" *ngIf="data.createdAt && api.env.useGuichet">
        <span>{{'print.withdrawal.date' | translate}}:</span><span>{{addBusinessDays(data.createdAt, 5) | date:'dd/MM/yyyy'}}</span>
      </div>
    </ng-container>
  </div>

  <div class="printFrame frame_br">
    <img class="printFrame_bg" *ngIf="api.env.showBackground" src="./assets/images/print_bg.png" alt="">
    <span class="frame_number">3</span>
    <div class="flex f_align_c mb_10">
      <img class="printFrame_header_icon" src="assets/images/icons_clr/qr.png">
      <span class="frame_title">{{'print.qr.title' | translate}}</span>
    </div>
    <div>
      <div class="flex f_col gap_10">
        <app-paragraph *ngIf="(data.subState === RequestSubState.REFUSED_IN || data.subState === RequestSubState.REFUSED_OUT) || data.timeslot || !api.env.useGuichet"
          innerhtml="{{('print.desc.part1' + ((data.subState === RequestSubState.REFUSED_IN || data.subState === RequestSubState.REFUSED_OUT) ? '.refuse' : '')) | translate}}" textAlign="justify"></app-paragraph>
        <app-paragraph innerhtml="{{('print.terms') | translate}}" textAlign="justify"></app-paragraph>
      </div>
    </div>
    <div *ngIf="data.timeslot">
      <h1 class="text_center"><b>{{data.timeslot_place_id}}<br>{{data.timeslot | date:'dd/MM/yyyy HH:mm':'UTC'}}</b></h1>
    </div>
    <div class="qr-container qr-double">
      <div class="qr-item">
        <qrcode *ngIf="isValid || api.env.alwaysShowQr" elementType="svg" errorCorrectionLevel="M" [qrdata]="data.qrCode" [width]="150"></qrcode>
        <div class="qr-label">{{ 'print.qr.application' | translate }}</div>
      </div>
      <div class="qr-item" *ngIf="api.env.showVerificationQr">
        <qrcode elementType="svg" errorCorrectionLevel="M" [qrdata]="data.qrCodeVerification" [width]="150"></qrcode>
        <div class="qr-label">{{ 'print.qr.verification' | translate }}</div>
      </div>
    </div>
  </div>
</div>
